import { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { useIsMobile } from '@/hooks/use-mobile';
import { useDashboardLayout } from '@/hooks/useDashboardLayout';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { ContentRouter } from '@/components/dashboard/ContentRouter';
import { MobileRouter } from '@/components/dashboard/MobileRouter';
import { useSetupGate, SETUP_GATE_ALLOWED_PATH } from '@/hooks/useSetupGate';

const Dashboard: React.FC = memo(() => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const setupGate = useSetupGate();
  const { routeType, currentRole } = useDashboardLayout();

  // Route-level setup lock: while a configuring admin's workspace setup is
  // incomplete, every route except Customise redirects back to it. This
  // enforces the sidebar's visual lock at the router so it can't be skipped
  // by editing the URL. Fails open (see useSetupGate); 'loading' renders
  // normally to avoid a first-paint delay for the common already-set-up case.
  if (setupGate === 'gated' && location.pathname !== SETUP_GATE_ALLOWED_PATH) {
    return <Navigate to={SETUP_GATE_ALLOWED_PATH} replace />;
  }

  // Mobile layout - return early if on mobile
  if (isMobile) {
    return <MobileRouter />;
  }


  return (
    <ErrorBoundary>
      <DashboardLayout>
        <ContentRouter 
          routeType={routeType}
          currentRole={currentRole}
        />
      </DashboardLayout>
    </ErrorBoundary>
  );
});

export default Dashboard;
